import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import Root from '@/Root';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);

/* Register the PWA service worker (production only — CRA dev server interferes). */
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .catch(() => {
        /* soft-fail — the site still works without the SW */
      });
  });
}
